
import React, { useEffect, useState } from 'react'
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { useHistory, useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useDispatch,useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMinusCircle, faPlusCircle, faCartShopping, } from '@fortawesome/free-solid-svg-icons'
import { addItemToCart } from "../../redux/reducers/cart.reducer";
import { makeStyles } from "@mui/styles/";
import { toast } from "react-toastify";
import firebase from 'firebase';
import moment from "moment";
const useStyles = makeStyles({
    cartCard: {
        borderBottomWidth: 1,
        borderRadius: 10,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'center',
        width: '100%',
        paddingVertical: 5,
        paddingBottom: 5,
        marginVertical: 5
    },
    info: {
        display: 'flex',
        flexDirection: 'column',
    },
    productItemCounterView: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

    },
    productPriceView: {
        marginTop: 10,
        justifyContent: "flex-end",
        flexDirection: "column",
        alignItems: "center",
    },
    counterValue: {
        fontSize: 20,
        fontWeight: '500',
    },

    toggleCounterButton: {
        paddingHorizontal: 10,
        fontSize: 20,
    },
    discountedPriceText: {
        color: "green",
        fontWeight: "bold",
        fontSize: 13,
    },
    actualPriceText: {
        color: "#222",
        color: "red",
        fontWeight: "bold",
        textAlignVertical: "bottom", marginTop: 3, marginLeft: 8,
        textDecorationLine: "line-through",
        fontSize: 11,
    },
})

const CompareStoreItem = ({ productItem }) => {
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const userInfo = useSelector((state) => state.auth.user);
    const[ priceAfterDiscount,setPriceAfterDiscount] = useState(!!productItem.discount && Number(productItem.discount) > 0 ? productItem.price - (productItem.price * (Number(productItem.discount) / 100)) : undefined);
    const [cartLoading, setCartLoading] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const styles = useStyles();
    const customTheme = useTheme();
    const dispatch = useDispatch();
    useEffect(()=>{
        if (productItem.currentDiscountExpiry && productItem.currentDiscountExpiry != null) {
            const exp = productItem.currentDiscountExpiry;
           const isValid = moment(new Date()).isSameOrBefore(exp);
            const diff = moment().diff(exp, 'days');
            
            console.log("isAfter : ",isValid);
            console.log("diff : ",diff);
            if(isValid &&(diff*-1)<=10){
                if (productItem.discount && Number(productItem.discount) > 0) {
                    
                    setPriceAfterDiscount( productItem.price - (productItem.price * (Number(productItem.discount) / 100)));
        
                }
            }
            if(!isValid){
                setPriceAfterDiscount(undefined);
            }
          }
    },[productItem])
    const handleAddItemToCart = (product) => {
          if (!userInfo?.isAnonymous) {
        setCartLoading(true);
        const createdAt = new firebase.firestore.Timestamp(product.createdAt._seconds, product.createdAt._nanoseconds,);
        let data = {
            ...product,
            createdAt: createdAt.toDate(),
            currentDiscountExpiry: product.currentDiscountExpiry ? new firebase.firestore.Timestamp(product.currentDiscountExpiry._seconds, product.currentDiscountExpiry._nanoseconds).toDate() : product.currentDiscountExpiry
        };
        
        if (product.currentDiscountExpiry && product.currentDiscountExpiry != null) {
            const exp = product.currentDiscountExpiry;
           const isValid = moment(new Date()).isSameOrBefore(exp);
            const diff = moment().diff(exp, 'days');
            
            console.log("isAfter : ",isValid);
            console.log("diff : ",diff);
            if(isValid &&(diff*-1)<=10){
                if (product.discount && Number(product.discount) > 0) {
                    data.priceAfterDiscount = product.price - (product.price * (Number(product.discount) / 100));
        
                }
              
            }
            if(!isValid){
                data.priceAfterDiscount =product.price;
            }
          }
       
        const productDateStringified = {
            ...data,
            cartQuantity: quantity,
            createdAt: data.createdAt.getTime(),
            currentDiscountExpiry: product.currentDiscountExpiry && product.currentDiscountExpiry.getTime ? product.currentDiscountExpiry.getTime() : product.currentDiscountExpiry
        }
        dispatch(addItemToCart(productDateStringified));
        setQuantity(1);
        setCartLoading(false);
        } 
         else {
            toast.error(`Oops! \n\n ${t("users.loginAsNormalUser")}`);
          };
    }
    return (
        <div style={{ width: "100%", paddingTop: 10, paddingBottom: 10,zIndex:100 }}>
            <div className={styles.cartCard} style={{ borderColor: customTheme.dark.primary, }}>
                <div onClick={() => {
                    history.push("/product/" + productItem.id)
                }} className={styles.info} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start" }}>

                        {productItem.storeInfo && productItem.storeInfo.image && productItem.image != '' && <img src={productItem.storeInfo.image} style={{ width: 60, height: 60, resizeMode: 'contain' }} />}
                    </div>
                </div>
                {productItem.storeInfo && (productItem.storeInfo[i18n.language == "ar" ? "nameAr" : "nameEn"] != undefined && productItem.storeInfo[i18n.language == "ar" ? "nameAr" : "nameEn"] != null) && <div onClick={() => {
                    history.push("/product/" + productItem.id)
                }} className={styles.info} style={{ cursor: "pointer" }} >

                    <Typography style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: 5, fontSize: 13, fontWeight: '400', color: "gray", }}>
                        {`${productItem.sizeOrCapacity ?? ""} ${productItem.measureUnit ?? ""} `}
                    </Typography>
                    <Typography style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: 10, fontSize: 13, fontWeight: '400', color: "gray" }}>
                        {`${productItem.brand ?? ""} , ${productItem.categoryInfo ? productItem.categoryInfo[i18n.language == "ar" ? "titleAr" : "titleEn"] : ""}`}
                    </Typography>
                    {productItem.price && (<div style={{ display: "flex", flexDirection: "row", marginRight: 5 }} >
                        <div className={styles.productPriceView}>
                            <Typography className={styles.discountedPriceText}>{`${new Number(priceAfterDiscount ?  priceAfterDiscount* quantity : productItem.price * quantity).toFixed(2)} ${t('product.currency')}`}</Typography>
                            {priceAfterDiscount && priceAfterDiscount > 0 && <Typography className={styles.actualPriceText}>{`${new Number(productItem.price * quantity).toFixed(2)} ${t('product.currency')}`}</Typography>}
                        </div>
                    </div>

                    )}
                </div>}
                <div className={styles.info} style={{ width: 80,flex:0 }}>
                    <div className={styles.productItemCounterView} style={{ bottom: 6 }}>
                        <div
                            style={{ cursor: "pointer", paddingLeft: 10, paddingRight: 10, }}
                            aria-disabled={quantity === 1 || cartLoading}
                            onClick={() => {
                                if (quantity > 1) {
                                    setQuantity(quantity - 1);
                                }
                            }}
                        >
                            <FontAwesomeIcon
                                className={styles.toggleCounterButton}
                                icon={faMinusCircle}
                            />
                        </div>
                        <Typography className={styles.counterValue}>
                            {quantity}
                        </Typography>
                        <div
                            style={{
                                cursor: "pointer",
                                paddingLeft: 10, paddingRight: 10,

                            }}
                            aria-disabled={cartLoading}
                            onClick={() => {
                                setQuantity(quantity + 1);
                            }}
                        >
                            <FontAwesomeIcon
                                className={styles.toggleCounterButton}
                                icon={faPlusCircle}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginTop: 20 }}>
                        <div
                            aria-disabled={cartLoading}
                            style={{ paddingHorizontal: 8, borderRadius: 4, cursor: "pointer" }}
                            onClick={() => handleAddItemToCart(productItem)}
                        >
                            <FontAwesomeIcon
                                style={{ color: customTheme.dark.dark, fontSize: 20 }}
                                icon={faCartShopping}

                            />
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
}

export default CompareStoreItem;